<template>
  <div>
    <HMModalHeader
      :title="$t('SETTINGS.BUTTON.EDIT_CONTACT_INFO')"
      @close="$emit('close')"
    />
    <ValidationObserver ref="teacher-form" v-slot="{ invalid }">
      <form @submit.prevent="updateTeacherInfo" v-if="contactFormModel">
        <div class="row">
          <div class="col pt-3">
            <HMTextInput
              class="mb-2"
              vid="studio_name"
              :label="$t('SETTINGS.LABEL.STUDIO_NAME')"
              rules="required"
              v-model="contactFormModel.studio_name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.FIRST_NAME')"
              rules="required"
              v-model="contactFormModel.first_name"
            />
          </div>
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.LAST_NAME')"
              rules="required"
              v-model="contactFormModel.last_name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <HMTextInput
              class="mb-2"
              vid="web_link"
              :label="$t('SETTINGS.LABEL.WEBSITE')"
              v-model="contactFormModel.web_link"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.ADDRESS')"
              v-model="contactFormModel.address"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.CITY')"
              v-model="contactFormModel.city"
            />
          </div>
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.ZIP_CODE')"
              v-model="contactFormModel.zipcode"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.STATE_PROVINCE')"
              v-model="contactFormModel.state"
            />
          </div>
          <div class="col-6">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.COUNTRY')"
              v-model="contactFormModel.country"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <HMTextInput
              class="mb-2"
              :label="$t('SETTINGS.LABEL.PHONE')"
              v-model="contactFormModel.phone"
            />
          </div>
          <div class="col">
            <HMTextInput
              class="mb-2"
              vid="email"
              :label="$t('SETTINGS.LABEL.EMAIL')"
              rules="required"
              v-model.trim="contactFormModel.email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <HMTextarea
              class="mb-2"
              :label="$t('SETTINGS.LABEL.ADDITIONAL_INVOICE_INFORMATION')"
              v-model="contactFormModel.additional_invoice_info"
              :rows="3"
              :useDynamicHeight="true"
            />
          </div>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SAVE')"
          :disabled="invalid || inProgress"
          :loading="inProgress"
          @close="$emit('close')"
        >
          <template v-slot:close>
            <div></div>
          </template>
        </HMModalFooter>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { cloneDeep } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    ValidationObserver,
  },
  props: {
    contact: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      contactFormModel: null,
      inProgress: false,
    };
  },
  methods: {
    async updateTeacherInfo() {
      this.inProgress = true;
      try {
        const data = { teacher: this.contactFormModel };
        const dispatchPromise = await this.$store.dispatch(
          'user/updateTeacher',
          data
        );
        await this.$store.dispatch('setting/getAccountInfo');
        this.$emit('close');
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.CONTACT_INFORMATION_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Error saving contact information',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
  },
  mounted() {
    this.contactFormModel = cloneDeep(this.contact);
  },
});
</script>

<style lang="scss" scoped></style>
